module.exports = __webpack_public_path__ + "fb-open-graph-600x315-e6bdb7ba970cab9021d7e3f7a8ff937d.png";